import DownArrow from "@material-ui/icons/ArrowDropDown";
import UpArrow from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Refresh from "@material-ui/icons/Refresh";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import styles from "./stockStyles";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { firestore } from "../../fire";
import SharkIcon from "../icons/shark.png";
import HolderModal from "../../components/Modals/Holders Modal";
import { useDispatch, useSelector } from "react-redux";
import { ExDiveObject } from "./ExDiveObject";
import { EarningObject } from "./EarningObject";
import ActionTypes from "../../actions/types";

const InformationSection = ({ symbol, date, FetchDependendonCalender }) => {
  const newDate = moment(new Date()).format("YYYY-MM-DD");

  const [earningToolTip, setEarningToolTip] = useState("");
  const [exToolTip, setexToolTip] = useState("");
  const { quoteInfo, accessLevel, holderList, isMobile, refreshingQuote } =
    useSelector((state) => state.appReducer);
  const { holderModal } = useSelector((state) => state.OpenInterestState);

  const getSmallest = (filteredExdiv) => {
    var a = moment();
    const getSmallest = filteredExdiv.map((element) => {
      var b = moment(element.date);
      var difference = b.diff(a);
      return { ...element, difference: difference };
    });
    return getSmallest.sort((a, b) => a.difference - b.difference);
  };
  const dispatch = useDispatch();

  const setShowHolder = (newState) => {
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  };
  const fetchEarningDate = async () => {
    setEarningToolTip("");
    setexToolTip("");
    try {
      if (Object.values(quoteInfo > 0)) {
        let earning = await firestore
          .collection("calendars")
          .doc(quoteInfo.symbol.replace("/", "-"))
          .get();
        let data = earning.data();
        let filteredEarning = Object.values(data).filter(
          (obj) => obj.type === "Earnings"
        );
        let filteredExdiv = Object.values(data).filter(
          (obj) => obj.type === "ExDiv"
        );
        if (filteredEarning.length) {
          let getResult = getSmallest(filteredEarning);
          console.log("getResult", getResult);
          setEarningToolTip("Earnings: " + getResult[0].date);
        }
        if (filteredExdiv.length) {
          let getResult = getSmallest(filteredExdiv);
          setexToolTip("Dividend:" + getResult[0].date);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchEarningDate();
  }, [quoteInfo]);

  let lengthCheck = false;
  if (Object.keys(holderList).length > 0) {
    if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
      lengthCheck = true;
    }
  }
  const setShowModalHolder = () => {
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: {
        holderModal: false,
      },
    });
  };

  return (
    <div>
      {holderModal && lengthCheck && (
        <HolderModal
          accessLevel={accessLevel}
          isMobile={isMobile}
          holderList={holderList}
          showModal={holderModal}
          setShowModal={setShowModalHolder}
          symbol={symbol}
        />
      )}
      <Card style={isMobile ? styles.selectorsMobile : styles.selectors}>
        {refreshingQuote ? (
          <CircularProgress
            style={styles.circularSpinner}
            size={24}
            color="primary"
          />
        ) : quoteInfo && quoteInfo.symbol ? (
          <div>
            <Typography
              variant="inherit"
              component="h3"
              style={styles.companyText}
            >
              {/* {quoteInfo.companyName && !isMobile
                ? quoteInfo.companyName.substring(0, 12)
                : ""}{" "} */}
              {!isMobile
                ? `${quoteInfo.symbol}`
                : `${quoteInfo.symbol} $${(quoteInfo.latestPrice * 1).toFixed(
                  2
                )}`}
            </Typography>
            <div style={styles.stockPriceInfo}>
              {!isMobile && (
                <span
                  style={isMobile ? styles.stockPriceMobile : styles.stockPrice}
                >
                  ${(quoteInfo.latestPrice * 1).toFixed(2)}
                </span>
              )}

              <span
                style={
                  quoteInfo.change < 0
                    ? styles.negPriceChange
                    : styles.posPriceChange
                }
              >
                {quoteInfo.change < 0 ? (
                  <DownArrow
                    style={
                      isMobile ? styles.downArrowMobile : styles.downArrow
                    }
                  />
                ) : (
                  <UpArrow
                    style={isMobile ? styles.upArrowMobile : styles.upArrow}
                  />
                )}{" "}
                <span style={{ ...styles.change, marginRight: "3px" }}>
                  ${Math.abs(quoteInfo.change).toFixed(2)}
                </span>
                ({Math.abs(quoteInfo.changePercent).toFixed(2)}
                %)
              </span>

              <IconButton
                aria-label="Refresh"
                disabled={refreshingQuote}
                size="small"
                color="primary"
                style={styles.refreshButton}
                onClick={() => FetchDependendonCalender(quoteInfo.symbol, date)}
              >
                <Refresh />
              </IconButton>
              {/* )} */}
            </div>
            <div style={{ display: "flex" }}>
              <Typography
                variant="body1"
                component="div"
                style={styles.timestampText}
              >
                As of
                {moment(date).isBefore(newDate) ? (
                  <span style={{ marginLeft: "2px" }}>
                    {moment(date).format("MMM DD")} 4:00pm{" "}
                  </span>
                ) : (
                  <span style={{ marginLeft: "2px" }}>
                    {moment(quoteInfo.latestUpdate).format("MMM DD h:mma")}
                  </span>
                )}
              </Typography>
              <div style={{ display: "flex" }}>
                {earningToolTip !== "" && !isMobile ? (
                  <EarningObject
                    isMobile={isMobile}
                    earningToolTip={earningToolTip}
                  />
                ) : (
                  ""
                )}
                {exToolTip !== "" && !isMobile ? (
                  <ExDiveObject isMobile={isMobile} exToolTip={exToolTip} />
                ) : (
                  ""
                )}
              </div>
              {lengthCheck ? (
                <div
                  style={{
                    height: "20px",
                    width: "20px",
                    marginLeft: "10px",
                  }}
                  onClick={() => setShowHolder({ holderModal: true })}
                >
                  <img height="100%" width="100%" src={SharkIcon} alt="" />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <Typography
            variant="inherit"
            component="h3"
            style={styles.noTickerText}
          >
            Enter a stock ticker to your left & click 'Go'
          </Typography>
        )}
      </Card>
    </div>
  );
};

export default InformationSection;



// WEBPACK FOOTER //
// ./src/Pages/Stock/tickerInformationSection.js